<div class="ng-dropdown" [class.ng-dropdown-visible]="visible" #dropdownContainer>
  <ng-container [style.visibility]="visible ? 'visible' : 'hidden'">
    <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="templateOutletContext"></ng-template>
  </ng-container>
</div>
